import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { keys, omit } from 'lodash-es';
import { TextButton, useOverlayContext } from 'seagull';
import { useTableListContext } from 'seagull/components/TableList/TableList.utils';
import { FilterSmall } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import Filter from '../Filter/Filter';
import { MobileAddFilterList } from '../MobileAddFilterList/MobileAddFilterList';
import { MobileFilterList } from '../MobileFilterList/MobileFilterList';
import { makeInitialFilterValue } from '../TableFilters.utils';
export const GetMobileTableFiltersTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileTableFilters = (param)=>{
    let { testIdPrefix, filterLabels, filterConfig, selectedFilters, onRefresh, setSelectedFilters, filterGroups, mobile } = param;
    const { MobileTableFiltersTID } = useMemo(()=>GetMobileTableFiltersTID(testIdPrefix), [
        testIdPrefix
    ]);
    const { sort } = useTableListContext();
    const { showBottomSheet, pushBottomSheetPage, hideBottomSheet } = useOverlayContext();
    const draftRef = useRef({});
    const activeFilterCount = keys(selectedFilters).length;
    const triggerLabel = activeFilterCount > 0 ? "Filter (".concat(activeFilterCount, ")") : 'Filter';
    function removeFilter(filter) {
        draftRef.current = omit(draftRef.current, filter);
        renderFilterListSheet(draftRef.current);
    }
    function openFilterSheet(filter) {
        pushBottomSheetPage({
            content: /*#__PURE__*/ _jsx(Filter, {
                testIdPrefix: testIdPrefix,
                label: filterLabels[filter],
                filter: filter,
                filterConfig: filterConfig[filter],
                selectedFilter: draftRef.current[filter],
                onChange: (value)=>{
                    draftRef.current = _object_spread_props(_object_spread({}, draftRef.current), {
                        [filter]: value
                    });
                    renderFilterListSheet(draftRef.current);
                },
                onRemove: ()=>{}
            })
        });
    }
    function apply() {
        setSelectedFilters(draftRef.current);
        onRefresh(draftRef.current, sort);
        hideBottomSheet();
    }
    function renderFilterListSheet(draft) {
        const draftKeys = keys(draft);
        const allFilterKeys = keys(filterConfig);
        const availableFilters = allFilterKeys.filter((f)=>!draftKeys.includes(f));
        const formatDescription = mobile === null || mobile === void 0 ? void 0 : mobile.formatFilterDescription;
        const filterDescriptions = formatDescription ? draftKeys.reduce((acc, filterKey)=>{
            const description = formatDescription(filterKey, draft[filterKey]);
            if (description) acc[filterKey] = description;
            return acc;
        }, {}) : undefined;
        showBottomSheet({
            content: /*#__PURE__*/ _jsx(MobileFilterList, {
                testId: testIdPrefix,
                filterLabels: filterLabels,
                filterDescriptions: filterDescriptions,
                draftFilterKeys: draftKeys,
                hasAvailableFilters: availableFilters.length > 0,
                onRemoveFilter: removeFilter,
                onFilterClick: openFilterSheet,
                onApply: apply,
                onAddFilterClick: ()=>{
                    pushBottomSheetPage({
                        content: /*#__PURE__*/ _jsx(MobileAddFilterList, {
                            filterLabels: filterLabels,
                            availableFilters: availableFilters,
                            groups: filterGroups,
                            onSelect: (filter)=>{
                                draftRef.current = _object_spread_props(_object_spread({}, draftRef.current), {
                                    [filter]: makeInitialFilterValue(filterConfig[filter])
                                });
                                renderFilterListSheet(draftRef.current);
                                openFilterSheet(filter);
                            }
                        })
                    });
                }
            })
        });
    }
    function handleTriggerClick() {
        draftRef.current = _object_spread({}, selectedFilters);
        renderFilterListSheet(draftRef.current);
    }
    return /*#__PURE__*/ _jsx(TextButton, {
        testId: MobileTableFiltersTID.TriggerButton(),
        underline: "none",
        prefixIcon: /*#__PURE__*/ _jsx(FilterSmall, {}),
        onClick: handleTriggerClick,
        children: triggerLabel
    });
};
